import api from './index'
//
let exports = {}
exports.getCustTagMetaFields = function(data, callback) {
    api.post('/objTag/objTagConf/getCustTagMetaFields')
        .data(data)
        .done(callback)
        .go()
}

export default exports



//////////////////
// WEBPACK FOOTER
// ./src/api/objTagConf.js
// module id = 67
// module chunks = 0